import { render, staticRenderFns } from "./ProtestoBoleto.vue?vue&type=template&id=f18e8992&"
import script from "./ProtestoBoleto.vue?vue&type=script&lang=js&"
export * from "./ProtestoBoleto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports